import styles from '@/styles/topReview/crazySale.module.scss'
import { useState, useEffect } from 'react'
import { Timer } from '@/utils/countDown'
import Link from 'next/link'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'

import Image from 'next/image'

import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain

dayjs.extend(duration)

interface CrazySaleProps {
  productID: string;
  name: string;
  url: string;
  imgUrl: string;
  review: number;
  reviewCount: number;
  price: number;
  normalPrice: number;
  freeShipping: number;
  onSale: number;
  reduced: number;
  isNew: number;
  position?: number,
  location?: string;
  isEmailOnly: any,
  promotionTypeID: string | number;
  promotion: {
    productID: number;
    promotionType: number;
    promotionPrice: number;
    normalPrice: number;
    endDate: string;
    status: number;
    notified: number;
    pointRate: string;
    promotionRate: number;
  };
  crazyDeal: {
    hoursLeft: number;
    minutesLeft: number;
    secondsLeft: number;
  } | undefined
}

export default function TopReviewCrazySale(props: CrazySaleProps) {

  let timer = new Timer()
  interface TimeRemaining {
    days: number,
    hours: string,
    minutes: string,
    seconds: string,
    isEnd: boolean,
  }

  // 倒计时计算
  const [days, setDays] = useState(0)
  const [timeDetail, setTimeDetail] = useState<string[]>([])
  function countDown(times: Date | number) {
    timer.countDown(times, (timeRemaining: TimeRemaining) => {
      if (timeRemaining.isEnd) { // 倒计时结束了
        if (props.promotion.promotionType == 1) {
          location.reload()
        }
      } else { // 正在倒计时
        let timeDetail: string[] = []
        const { days, hours, minutes, seconds, isEnd } = timeRemaining
        if (isEnd) return
        let hh: string | number = days * 24 + parseInt(hours)
        if (hh <= 99) {
          hh < 10 ? hh = '0' + hh : hh = `${hh}`
          const [h1, h2] = hh.split('')
          timeDetail.push(h1, h2)
        } else {
          timeDetail.push('9', '9')
        }
        const [m1, m2] = minutes.split('')
        const [s1, s2] = seconds.split('')
        timeDetail = [...timeDetail, m1, m2, s1, s2]
        setTimeDetail(timeDetail)
      }
    })
  }

  useEffect(() => {
    // csotd, 从数据返回拿
    if (
      props.promotion.promotionType == 1
      && (props.crazyDeal?.hoursLeft || props.crazyDeal?.minutesLeft || props.crazyDeal?.secondsLeft)
    ) {
      setDays(days)
      // 结束时间
      const time = new Date().getTime() + (60 * 60 * props.crazyDeal.hoursLeft + 60 * props.crazyDeal.minutesLeft + props.crazyDeal.secondsLeft) * 1000
      countDown(time)
    }
  }, [])

  return (
    <>
      <div className={styles['comp-crazy-sale']}>
        <Image
          className={styles['banner']}
          src={`${imageDomain}/top-review/crazy-sale-banner.png`}
          alt={'banner'}
          width={240}
          height={40}></Image>

        <div className={styles['product-box']}>

          <Link 
            href={`${props.url}`}
            passHref
            legacyBehavior
          >
            <a rel="noopener noreferrer">
              <Image
                className={styles['product-banner']}
                src={props.imgUrl}
                alt={props.name}
                priority={true}
                width={208}
                height={208}></Image>
                
                
              <div className={styles['time-left-box']}>
                <div className={styles['time-left-text']}>Time Left</div>
                <div className={styles['time-left-sign']}></div>
                <div className={styles['time-text']}>
                  {timeDetail[0]}
                  {timeDetail[1]}:
                  {timeDetail[2]}
                  {timeDetail[3]}:
                  {timeDetail[4]}
                  {timeDetail[5]}
                </div>
              </div>

              <div className={styles['product-name']}>{props.name}</div>

              <div className={styles['price-info']}>
                <div className={styles['promotion-price']}>
                  <b>${ props.price }</b>
                </div>
                <div className={styles['normal-price']}>${ props.normalPrice }</div>
              </div>
            </a>
          </Link>

          <Link 
            href={`/bestdealoftheday`}
            passHref
            legacyBehavior
          >
            <a rel="noopener noreferrer">
              <div className={styles['buy-now-btn']}>Buy Now</div>
            </a>
          </Link>

          <div className={styles['tips']}>24 hours only!Don’t Miss Out</div>
        </div>
      </div>
    </>
  )
}